
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from '../components/explanations/indirect-speech-explanation';
const mainimage = '/Images/homebakery1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "indirectspeech" },
];


const IndirectSpeech = () => (
  <GrammarPageLayout
    level="B2"
    title="Indirect Speech"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Indirect Speech Exercises"
    seoDescription="Learn how to report what someone said without using their exact words. B2 level exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B2"
  />
);

export default IndirectSpeech;
